export default "__VITE_ASSET__796aeba2__"